<template>
    <div class="">

        <!-- Table -->
        <ajax-table :data="data"
                    :headers="headers"
                    v-model:loading="ajaxTable.loading"
                    v-model:search="ajaxTable.search"
                    v-model:sort-by="ajaxTable.sortBy"
                    v-model:sort-desc="ajaxTable.sortDesc"
                    v-model:page="ajaxTable.page"
                    v-model:items-per-page="ajaxTable.itemsPerPage"
                    v-model:page-info="ajaxTable.pageInfo"
                    @rowSelected="showFoodBatch"
                    :exportable="false"
                    @loadData="getData"
                    no-data-message="No batches found yet"
        >

            <template #above_table_center>
                <div v-if="permissions.can('create_vacation')"
                     class="self-start flex items-center w-full md:w-auto ml:0 md:ml-2">
                    <green-button @click="createFoodBatch"
                    >
                        <div class="inline-flex">
                            <span class="lnr icon-plus-circle mr-2"></span>
                            <span>Create Batch</span>
                        </div>
                    </green-button>
                </div>
            </template>

            <!-- Column 1: User Name-->
            <template #col-1="props">
                <div class="flex flex-col items-start justify-center">
                    <span class="my-1 text-gray-700">
                      <div class="font-medium text-gray-900">{{ props.row.zone_name }}</div>
                      <div class="font-medium text-gray-900">{{ props.row.originating_user.display_name }}</div>
                      <div class="text-gray-500">Requested on {{ props.row.created_at_readable }}</div>
                    </span>
                </div>
            </template>

            <!-- Column 2: Batch Details-->
            <template #col-2="props">
                <div class="flex flex-col items-start justify-center">
                  <div class="font-medium text-gray-900">{{ props.row.action }} {{ props.row.food}}</div>
                  <div class="font-medium text-gray-900">Lot {{ props.row.lot }}</div>
                  <div v-if="props.row.limiting_value" class="text-gray-500">Limiting Value: {{ props.row.limiting_value }}&deg; F</div>

                </div>
            </template>

            <!-- Column 3: Vacation Info -->
            <template #col-3="props">
                <div class="flex flex-col items-start justify-center">
                                      <span class="my-1 text-gray-700">
                                          <span v-if="props.row.status === 'active'"
                                                class="-ml-2 inline-flex items-center rounded-full bg-blue-100 px-2.5 py-0.5 text-md font-medium text-blue-800">
                                              Active
                                            <span class="relative flex h-3 w-3">
                                              <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75"></span>
                                              <span class="relative inline-flex rounded-full h-3 w-3 bg-sky-500"></span>
                                            </span>
                                          </span>
                                          <span v-else-if="props.row.status === 'complete'"
                                                class="-ml-2 inline-flex items-center rounded-full bg-green-100 px-2.5 py-0.5 text-md font-medium text-green-800">
                                              Completed
                                          </span>
                                          <span v-else-if="props.row.status === 'violation'"
                                                class="-ml-2 inline-flex items-center rounded-full bg-red-100 px-2.5 py-0.5 text-md font-medium text-red-800">
                                              Violation
                                          </span>
                                          <span v-else-if="props.row.status === 'overridden'"
                                                class="-ml-2 inline-flex items-center rounded-full bg-yellow-100 px-2.5 py-0.5 text-md font-medium text-yellow-800">
                                              Overridden
                                          </span>
                                      </span>
                </div>
            </template>

            <!-- Column 4: Vacation Status-->
<!--            <template #col-4="props">-->
<!--                <div class="flex flex-col items-start justify-center">-->
<!--                    <span class="my-1 text-gray-700">-->
<!--                        <span v-if="props.row.approval_status === 1"-->
<!--                              class="-ml-2 inline-flex items-center rounded-full bg-gray-100 px-2.5 py-0.5 text-md font-medium text-gray-800">-->
<!--                            Pending Approval-->
<!--                        </span>-->
<!--                        <span v-else-if="props.row.status === 1 && props.row.approval_status === 2"-->
<!--                              class="-ml-2 inline-flex items-center rounded-full bg-blue-100 px-2.5 py-0.5 text-md font-medium text-blue-800">-->
<!--                            Starts {{ props.row.starts_in_complex }}-->
<!--                        </span>-->
<!--                        <span v-else-if="props.row.status === 2"-->
<!--                              class="flex">-->
<!--                            <span class="-ml-2 inline-flex items-center rounded-full bg-green-100 px-2.5 py-0.5 text-md font-medium text-green-800">-->
<!--                                Active-->
<!--                            </span>-->
<!--                            <span class="relative flex h-3 w-3">-->
<!--                                <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75"></span>-->
<!--                                <span class="relative inline-flex rounded-full h-3 w-3 bg-sky-500"></span>-->
<!--                            </span>-->
<!--                        </span>-->
<!--                        <span v-else-if="props.row.status === 3"-->
<!--                              class="-ml-2 inline-flex items-center rounded-full bg-green-100 px-2.5 py-0.5 text-md font-medium text-green-800">-->
<!--                            Completed-->
<!--                        </span>-->
<!--                        <span v-else-if="props.row.status === 4"-->
<!--                              class="-ml-2 inline-flex items-center rounded-full bg-gray-100 px-2.5 py-0.5 text-md font-medium text-gray-800">-->
<!--                            Expired-->
<!--                        </span>-->
<!--                        <span v-else-if="props.row.status === 5"-->
<!--                              class="-ml-2 inline-flex items-center rounded-full bg-gray-100 px-2.5 py-0.5 text-md font-medium text-gray-800">-->
<!--                            Cancelled-->
<!--                        </span>-->
<!--                    </span>-->
<!--                </div>-->
<!--            </template>-->

        </ajax-table>


        <!--    Notification modal for the results -->
        <notification-modal
                v-model:is-open="showResultModal"
        >
            <template #title-content>
                Update Successful!
            </template>
            {{ modalText }}
        </notification-modal>

    </div>
</template>
<script>

import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import Pagination from "@/components/Pagination"
import ItemsPerPageSelect from "@/components/ItemsPerPageSelect"
import FloatingInput from "@/components/elements/FloatingInput";
import Select2 from '@/components/elements/select2'
import GreenButton from "@/components/elements/green-button";
import AjaxTable from "@/components/elements/AjaxTable";
import {ajaxTableMixin} from "@/mixins/ajaxTableMixin";
import Loading from "@/components/elements/loading";
import SmallColoredCheck from "@/components/elements/SmallColoredCheck";
import {UrlParamsMixin} from "@/mixins/UrlParamsMixin";
import _isNil from "lodash";
import AlarmProfileEdit from "@/components/alarmProfiles/alarmProfilesEdit";
import _ from "lodash";

export default {
    name: "FoodBatchIndex",
    mixins: [SonicuCoreMixin, iconNamesMixin, ajaxTableMixin, UrlParamsMixin],
    components: {
        SmallColoredCheck,
        Loading, AjaxTable, GreenButton, Pagination, ItemsPerPageSelect, FloatingInput, Select2
    },
    data() {
        return {
            data: [],
            headers: [
                {
                    name: 'Requesting Info',
                    sortBy: '',
                    show: 'sm',
                    key: 'id',
                },
                {
                    name: 'Batch Details',
                    sortBy: '',
                    show: 'sm',
                    key: 'batch_details',
                },
                {
                    name: 'Status',
                    sortBy: '',
                    show: 'sm',
                    key: 'status',
                },
            ],
            requestNumber: 0,
            processing: false,

            // For Modal
            selectedReminder: null,
            selectedReminderIndex: null,
            showReminder: false,
            showResultModal: false,
            modalText: '',

        }
    },
    created() {
    },
    mounted() {
    },
    methods: {
        getData() {
            this.ajaxTable.loading = true
            this.requestNumber++
            let params = JSON.parse(JSON.stringify(this.ajaxTable))
            params.requestNumber = this.requestNumber
            axios.get(this.company.buildCompanyApiInternalRoute('food-batches'),
                {
                    params: params,
                }
            ).then(response => {
                let data = response.data;
                if (data.meta.requestNumber !== this.requestNumber) {
                    console.log('skipping data', data.meta.requestNumber, this.requestNumber)
                    return
                }
                this.ajaxUpdateTableData(data); // This sends the data to the mixin for AjaxTable
                this.data = !_.isNil(data.data) ? data.data : [];
            }).catch(error => {
                console.log(error)
            }).then(() => {
                this.ajaxTable.loading = false
            })
        },
        showFoodBatch(rowIndex) {
            window.location.href = this.company.buildCompanyRoute(`food-batches/${this.data[rowIndex].id}`)
        },
        createFoodBatch() {
            window.location.href = this.company.buildCompanyRoute(`food-batches/create`)
        },
    },
    computed: {},
    watch: {},
}
</script>

<style scoped>

</style>